(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["accordion"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('accordion-block')) {
    customElements.define(
      'accordion-block',
      class ScrollToSection extends HTMLElement {
        constructor() {
          super();

          this.isOpen = this.getAttribute('data-open') === 'true';
          this.autoClose = this.getAttribute('data-auto-close') === 'true';
          this.summary = this.querySelector('.accordion-block__summary');
          this.summaryButton = this.summary.querySelector('button');
          this.parentSection = this.closest('.js-accordion-wrapper') ?? this.closest('.shopify-section');
        }

        connectedCallback() {
          this.summary.addEventListener('click', () => {
            this.isOpen = this.getAttribute('data-open') === 'true';
            if (this.isOpen) {
              this.close();
            } else {
              this.open();
            }
          });

          // open on enter click if button is in focus
          this.summaryButton.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              this.isOpen = this.getAttribute('data-open') === 'true';
              if (this.isOpen) {
                this.close();
              } else {
                this.open();
              }
            }
          });
        }

        open() {
          if (this.autoClose && this.parentSection) {
            const openAccordions = this.parentSection.querySelectorAll(
              'accordion-block[data-auto-close="true"][data-open="true"]'
            );
            openAccordions.forEach((accordion) => {
              if (accordion !== this) {
                accordion.close();
              }
            });
          }
          this.setAttribute('data-open', 'true');
          this.summaryButton.setAttribute('aria-expanded', 'true');
        }

        close() {
          this.setAttribute('data-open', 'false');
          this.summaryButton.setAttribute('aria-expanded', 'false');
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["mega-menu"] && !Shopify.designMode) return;
  try {
    class Megamenu extends HTMLElement {
    constructor() {
      super();

      this.hideDelay = 200;

      this.allItems = document.querySelectorAll('.mega-menu__item');
      this.allTriggers = document.querySelectorAll('.js-mega-hover');
      this.subLinkTriggers = document.querySelectorAll('.js-mega-toggle');
      this.subLinkContainers = document.querySelectorAll('.mega-menu-links[data-level-block]');

      this.curEl = null;
      this.menuItem = null;
      this.menuIndex = null;

      this.hideTimeout = null;
      this.lastScrollY = 0;
    }

    connectedCallback() {
      this.allTriggers.forEach((menuItemEl) => {
        menuItemEl.addEventListener('mouseenter', () => {
          this.clearHideTimeout();

          this.menuItem = menuItemEl;
          this.menuIndex = menuItemEl.getAttribute('data-menu-index');

          this.showMegaMenu();
          this.showMegamenuItem();
        });
      });

      this.subLinkTriggers.forEach((subLinkTrigger) => {
        subLinkTrigger.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();

          if (subLinkTrigger.classList.contains('active')) return;

          const item = subLinkTrigger.getAttribute('data-level-item');
          const block = subLinkTrigger.getAttribute('data-level-block');

          const levelTriggers = document.querySelectorAll(`.js-mega-toggle[data-level-item="${item}"]`);

          const levelBlocks = document.querySelectorAll(`.mega-menu-links[data-level-item="${item}"]`);

          const subLinkContainer = document.querySelector(
            `.mega-menu-links[data-level-item="${item}"][data-level-block="${block}"]`
          );

          if (subLinkContainer) {
            levelTriggers.forEach((trigger) => trigger.classList.remove('active'));
            levelBlocks.forEach((container) => container.classList.add('hidden'));

            subLinkTrigger.classList.add('active');
            subLinkContainer.classList.remove('hidden');
          }
        });
      });

      this.addEventListener('mouseenter', () => {
        this.clearHideTimeout();
        this.showMegaMenu();
      });

      this.addEventListener('mouseleave', () => {
        this.hideMegaMenu();
      });

      window.addEventListener('scroll', () => {
        const currentScrollY = window.scrollY;

        if (currentScrollY > this.lastScrollY && currentScrollY > 100) {
          this.forceHideMegaMenu();
        }

        this.lastScrollY = currentScrollY;
      });
    }

    clearHideTimeout() {
      if (!this.hideTimeout) return;

      window.clearTimeout(this.hideTimeout);
      this.hideTimeout = null;
    }

    showMegaMenu() {
      this.clearHideTimeout();
      this.classList.add('active');

      document.body.classList.add('blur', 'megamenu--active');

      this.showMegamenuItem();

      if (document.body.classList.contains('drawer--active')) {
        document.querySelectorAll('side-drawer.active').forEach((drawer) => {
          drawer.dispatchEvent(new Event('drawer-toggle'));
        });
      }
    }

    showMegamenuItem() {
      this.allItems.forEach((item) => item.classList.remove('active'));
      this.allTriggers.forEach((trigger) => trigger.classList.remove('active'));

      if (!this.menuItem) return;

      this.menuItem.classList.add('active');

      const target = Array.from(this.allItems).find((item) => item.dataset.menuIndex === this.menuIndex);

      if (target) {
        target.classList.add('active');
      }
    }

    forceHideMegaMenu() {
      this.clearHideTimeout();
      this.classList.remove('active');

      document.body.classList.remove('blur', 'megamenu--active');

      this.allTriggers.forEach((trigger) => trigger.classList.remove('active'));
      this.allItems.forEach((item) => item.classList.remove('active'));

      this.menuItem = null;
    }

    hideMegaMenu() {
      this.clearHideTimeout();
      this.hideTimeout = window.setTimeout(() => {
        this.forceHideMegaMenu();
      }, this.hideDelay);
    }
  }

  customElements.define('mega-menu', Megamenu);
  } catch(e) { console.error(e); }
})();

})();
